import React from 'react';
import { TableViewComponent } from '../../../../ui-components/data-viz-ui/table/TableViewComponent';
import { OverTimeSegmentedTableViewUiComponentProps } from './types';

export const OverTimeTableViewUiComponent = (
  props: OverTimeSegmentedTableViewUiComponentProps
) => {
  return <TableViewComponent {...props} />;
};
